import { FunctionComponent } from 'react';
import { SearchType } from 'components/search/utils';
import { useSearchRedirect } from 'components/search/useSearchRedirect';

interface SearchRedirectProps {
  type: SearchType;
}

export const SearchRedirect: FunctionComponent<SearchRedirectProps> = ({ type }) => {
  useSearchRedirect(type);
  return null;
};
